import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
declare var $:any;

@Component({
  selector: 'app-search-mobile',
  templateUrl: './search-mobile.component.html',
  styleUrls: ['./search-mobile.component.css']
})
export class SearchMobileComponent implements OnInit {

  keyword:string = '';  
  exturl:string = '';
  searchForm:FormGroup;  
  data = [];
  constructor(private frmbuilder:FormBuilder,private searchservice:DataService) {
    this.searchForm = frmbuilder.group({
    s:['',[Validators.required,Validators.minLength(2)]]     
    });
  }
  notFoundTemplate:boolean = false;
  ngOnInit(): void {
    $('.search-btn').click(() =>{
      $(this).next('.search_section').toggleClass('active');
       return false;
   });
   $('.close_search').click(() =>{
       $(this).closest('.search_section').removeClass('active');
       return false;
   });
  }
  onSubmit(){   
    if(this.exturl!=null){     
     window.location.href = this.exturl;
    //window.location.assign(this.exturl);
    //$("input:text").val("");
    }    
  }
  searchKeywordMobile(event:any){
    let val=event.target.value;
    if(val.length<3){
      document.getElementById('suggestion-box-mobile')!.style.display="none";
      document.getElementById('mobile-search-icon')!.style.display="block";
      return false;
    }
    this.searchservice.search(val).subscribe((response:any)=>{ 
      if(val.length>0){ 
      document.getElementById('suggestion-box-mobile')!.style.display="block";
      document.getElementById('mobile-search-icon')!.style.display="none";

               
      this.data = response["data"];
      if(this.data.length == 0){
        this.notFoundTemplate = true;
      }
      else{
        this.notFoundTemplate = false;;
      }
      }
      else{
        this.notFoundTemplate = true;
      }  
     });
     return;
   }
   setKeywordMobile(searchobj:any){
    this.exturl = searchobj.link;
    this.keyword = searchobj.keyword; 
    //this.searchForm.submit();
    this.onSubmit();
    document.getElementById('suggestion-box-mobile')!.style.display="none"; 
    document.getElementById('mobile-search-icon')!.style.display="block";
      
    }
    openSuggestionBoxMobile(event:any){
      let val=event.target.value;
      if(val.length>0){
     document.getElementById("suggestion-box-mobile")!.style.display="block";
     document.getElementById('mobile-search-icon')!.style.display="none";
      }
    }
    hideSuggestionDivMobile(){
    document.getElementById("suggestion-box-mobile")!.style.display="none";
    document.getElementById('mobile-search-icon')!.style.display="block";
     } 

}
